import { useData } from '../DataProvider';
import './ContactPage.css'

const ContactPage = () => {

    const { data, loading } = useData();

    if (loading) {
        return <div></div>;
    }

    return (
        <div>
            <div style={{ position: 'relative', minHeight: 'calc(100vh - 50px)' }}>
                <div style={{ height: '80px' }}></div>
                <div className='page-margin'>
                    <div className='contact-text newline-able'>{data.texts['contact-us']}</div>
                    <div style={{ height: '80px' }}></div>
                    <div className='contact-info-container'>
                        <div style={{ width: '100%' }}>
                            <div className='default-text newline-able'>
                                {data.texts['contact-us-info']}
                            </div>
                        </div>
                        <div className='contact-gap'></div>
                        <div style={{ width: '100%' }}>
                            <div className='default-text newline-able'>
                                {data.texts['contact-us-info-2']}
                                <br />
                                <br />
                            </div>
                            <div className='default-text newline-able grey-text'>
                                {data.texts['contact-us-requirements']}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='footer-div'>
                <div className='line grey-line'></div>
                <div style={{display: 'flex', gap: '30px', padding: '5px'}}>
                    <div className='default-text grey-text' style={{paddingRight: '20px'}}>More about MINIMA</div>
                    <img src='icon-sns-1.png' alt='sns 1 icon' onClick={()=>window.open(data.texts['sns-1-link'])} style={{width: '30px', opacity: '50%'}}></img>
                    <img src='icon-sns-2.png' alt='sns 2 icon' onClick={()=>window.open(data.texts['sns-2-link'])} style={{width: '30px', opacity: '50%'}}></img>
                </div>
            </div>
        </div>
    );
}

export default ContactPage;
